// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile_bottom_navbar {
  overflow: hidden;
  background-color: rgb(241, 246, 247);
  /* background-color: var(--color-brand); */
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 1rem;
  z-index: 9999;
  display: flex;
  justify-content: space-between;
}

.mobile_cart {
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: auto;
  display: flex;
  position: relative;

}

.mobile_cart_count {
  /* background-color: black; */
  background-color: var(--color-brand);
  color: white;
  font-weight: 700;
  border-radius: 9999px;
  justify-content: center;
  align-items: center;
  display: flex;
  right: -.75rem;
  top: -.625rem;
  position: absolute;
  min-width: 20px;
  height: 20px;
  padding: 2px;
  /* border-radius: 63px; */
  font-size: 10px;

}

.overlay {
  background-color: rgba(0, 0, 0, .35);
  z-index: 21;
  visibility: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  opacity: 0;
  top: 0;
  z-index: 9999;
}

.overlay {
  transition: .35s ease-in-out;
}

.overlay.open {
  opacity: 1;
  visibility: visible;
}

.modal_login{
  width: 100%;
  padding: 2rem;
  margin: 2rem;
  border-radius: 0.6rem;
  height: fit-content;
}
.item-center{
  align-items: center;
}

.mobile_cart_new{
  width: 88%;
  right: 0px;
  top: 0;
  bottom: 0;
  position: absolute;
  z-index: 1050;
  overflow: hidden;
  transition: transform .3s;
  /* left: 0; */
  position: fixed;
  z-index: 1050;
  pointer-events: none;
  z-index: 9999;
}

.mobile_cart_content{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  pointer-events: auto;
}
.mobile_cart_content_nav{
  padding-inline-start: 1.25rem;
  /* padding-top: .125rem;
  padding-bottom: .125rem; */
  justify-content: space-between;
  align-items: center;
  width: 100%;
  display: flex;
  /* position: relative;s */
  box-sizing: border-box;
  border-bottom: 1px solid #dddddd;
  /* box-shadow: 5px solid #b9b8b8;; */
  padding: 1.6rem;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 9999;
}

.mobile_cart_content_body{
  height: 75%;

}
.mobile_cart_content_footer{
  bottom: 0;
  position: fixed;
  background-color: white;
  width: 88%;
}

.checkout_btn_mobile{
  --tw-text-opacity: 1;
  color: rgb(255 255 255);
  font-size: .875rem;
  line-height: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: .75rem;
  padding-bottom: .75rem;
  --tw-bg-opacity: 1;
  background-color: #0098b8;
  border-radius: .375rem;
  justify-content: center;
  align-items: center;
  width: 100%;
  display: flex;
}

.p_to_chkout{

}
.p_to_chkout_price{

}

.height_border{
  /* border-inline-start-width: 1px; */
  padding-inline-end: 0.7rem;
  padding-top: .125rem;
  padding-bottom: .125rem;
  border-color: rgb(255 255 255);
  box-sizing: border-box;
  /* border: 0 solid #f9f9f9; */
  --tw-text-opacity: 1;
  color: rgb(255 255 255);
  font-size: .875rem;
  line-height: 1.25rem;
  --tw-bg-opacity: 1;
  /* background-color: rgb(33 33 33); */
}

.best_sell_div{
  width: 310px;
}

.best_sell_image{
  height: 325px;
}
@media screen and (max-width: 768px) {
  .best_sell_div{
    width: 270px;
  }
}
@media screen and (max-width: 480px) {
  .best_sell_div{
    width: 100%;
  }
}
@media screen and (max-width: 320px) {
  .mobile_bottom_navbar{
    width: 94%;
  }
  /* .header-bottom{
    width: 107%;
  } */
  /* .site_width_mobile{
    width: 111%;
  } */
}`, "",{"version":3,"sources":["webpack://./src/assets/Css/mobile-menu.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;;AAEpB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;;AAEjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,UAAU;EACV,MAAM;EACN,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EAEE,6BAA6B;EAC7B;4BAC0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;;AAEb;AACA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;;AAEA;AACA;;AAEA;;AAEA;EACE,oCAAoC;EAEpC,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;;KAEG;EACH;;KAEG;AACL","sourcesContent":[".mobile_bottom_navbar {\n  overflow: hidden;\n  background-color: rgb(241, 246, 247);\n  /* background-color: var(--color-brand); */\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  padding: 1rem;\n  z-index: 9999;\n  display: flex;\n  justify-content: space-between;\n}\n\n.mobile_cart {\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  height: auto;\n  display: flex;\n  position: relative;\n\n}\n\n.mobile_cart_count {\n  /* background-color: black; */\n  background-color: var(--color-brand);\n  color: white;\n  font-weight: 700;\n  border-radius: 9999px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  right: -.75rem;\n  top: -.625rem;\n  position: absolute;\n  min-width: 20px;\n  height: 20px;\n  padding: 2px;\n  /* border-radius: 63px; */\n  font-size: 10px;\n\n}\n\n.overlay {\n  background-color: rgba(0, 0, 0, .35);\n  z-index: 21;\n  visibility: hidden;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: fixed;\n  opacity: 0;\n  top: 0;\n  z-index: 9999;\n}\n\n.overlay {\n  transition: .35s ease-in-out;\n}\n\n.overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal_login{\n  width: 100%;\n  padding: 2rem;\n  margin: 2rem;\n  border-radius: 0.6rem;\n  height: fit-content;\n}\n.item-center{\n  align-items: center;\n}\n\n.mobile_cart_new{\n  width: 88%;\n  right: 0px;\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  z-index: 1050;\n  overflow: hidden;\n  transition: transform .3s;\n  /* left: 0; */\n  position: fixed;\n  z-index: 1050;\n  pointer-events: none;\n  z-index: 9999;\n}\n\n.mobile_cart_content{\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #fff;\n  pointer-events: auto;\n}\n.mobile_cart_content_nav{\n  -webkit-padding-start: 1.25rem;\n  padding-inline-start: 1.25rem;\n  /* padding-top: .125rem;\n  padding-bottom: .125rem; */\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  display: flex;\n  /* position: relative;s */\n  box-sizing: border-box;\n  border-bottom: 1px solid #dddddd;\n  /* box-shadow: 5px solid #b9b8b8;; */\n  padding: 1.6rem;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 9999;\n}\n\n.mobile_cart_content_body{\n  height: 75%;\n\n}\n.mobile_cart_content_footer{\n  bottom: 0;\n  position: fixed;\n  background-color: white;\n  width: 88%;\n}\n\n.checkout_btn_mobile{\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255);\n  font-size: .875rem;\n  line-height: 1.25rem;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n  --tw-bg-opacity: 1;\n  background-color: #0098b8;\n  border-radius: .375rem;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  display: flex;\n}\n\n.p_to_chkout{\n\n}\n.p_to_chkout_price{\n\n}\n\n.height_border{\n  /* border-inline-start-width: 1px; */\n  -webkit-padding-end: 1.25rem;\n  padding-inline-end: 0.7rem;\n  padding-top: .125rem;\n  padding-bottom: .125rem;\n  border-color: rgb(255 255 255);\n  box-sizing: border-box;\n  /* border: 0 solid #f9f9f9; */\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255);\n  font-size: .875rem;\n  line-height: 1.25rem;\n  --tw-bg-opacity: 1;\n  /* background-color: rgb(33 33 33); */\n}\n\n.best_sell_div{\n  width: 310px;\n}\n\n.best_sell_image{\n  height: 325px;\n}\n@media screen and (max-width: 768px) {\n  .best_sell_div{\n    width: 270px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .best_sell_div{\n    width: 100%;\n  }\n}\n@media screen and (max-width: 320px) {\n  .mobile_bottom_navbar{\n    width: 94%;\n  }\n  /* .header-bottom{\n    width: 107%;\n  } */\n  /* .site_width_mobile{\n    width: 111%;\n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
